import { render } from "./CreditRequests.vue?vue&type=template&id=73980cdc&scoped=true"
import script from "./CreditRequests.vue?vue&type=script&lang=js"
export * from "./CreditRequests.vue?vue&type=script&lang=js"

import "./CreditRequests.vue?vue&type=style&index=0&id=73980cdc&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73980cdc"]])

export default __exports__